module.exports = __webpack_public_path__ + "media/hyper/images/users/avatar-4-3e2b67cd1c9ec6de4ef0c114306d25e8.jpg";